import { call, put } from 'redux-saga/effects';
import * as apiKeyActions from '../actions/apiKey';
import * as API from './api';

function* getApiKeys() {
  try {
    const apiKeys = yield call(API.getApiKeys);
    yield put({
      type: apiKeyActions.GET_API_KEYS_SUCCESS,
      payload: apiKeys,
    });
  } catch (error) {
    error.name = 'Could not get API Keys';
    yield put({ type: apiKeyActions.GET_API_KEYS_ERROR, payload: error });
  }
}

function* addApiKey(action) {
  try {
    const apiKey = yield call(API.addApiKey, action.payload.name);
    yield put({
      type: apiKeyActions.ADD_API_KEY_SUCCESS,
      payload: apiKey,
    });
  } catch (error) {
    error.name = 'Could not add API Key';
    yield put({ type: apiKeyActions.ADD_API_KEY_ERROR, payload: error });
  }
}

function* deleteApiKey(action) {
  try {
    yield call(API.deleteApiKey, action.payload.name);
    yield put({
      type: apiKeyActions.DELETE_API_KEY_SUCCESS,
      payload: action.payload,
    });
  } catch (error) {
    error.name = 'Could not delete API Key';
    yield put({ type: apiKeyActions.DELETE_API_KEY_ERROR, payload: error });
  }
}

const sagas = [
  [apiKeyActions.GET_API_KEYS, getApiKeys],
  [apiKeyActions.ADD_API_KEY, addApiKey],
  [apiKeyActions.DELETE_API_KEY, deleteApiKey],
];

export default sagas;
